import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles.scss';
import { Input } from 'react-toolbox';

const formatCurrency = (value) => {
  let num = value.split('').filter(c => c.match(/\d|\./)).join('');
  const dotIndex = num.indexOf('.');
  if (dotIndex > 0) {
    num = num.slice(0, dotIndex + 3);
  }
  return num;
};

class CurrencyInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value) {
    const newValue = formatCurrency(value);
    this.props.onChange(newValue);
  }

  render() {
    const newProps = { ...this.props, onChange: this.handleChange };
    return (
      <Input {...newProps}>
        <i className={styles.dollarSign}>$</i>
      </Input>
    );
  }
}

CurrencyInput.propTypes = {
  onChange: PropTypes.func,
};

export default CurrencyInput;



// WEBPACK FOOTER //
// ./client/app/shared/components/CurrencyInput/index.jsx